export default __webpack_public_path__ + "static/sorcerer-cbef5a2dc23c1515953e1ca68b9ce540.webp";